export default "__VITE_ASSET__MfYTVZCG__"